import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_DELIVERY_CITIES_APP_PATHS } from '../constants/delivery-cities-app-paths.constants';
import AdminDeliveryCitiesListView from '../views/admin/AdminDeliveryCitiesList.view';
import AdminDeliveryCityDetailsView from '../views/admin/AdminDeliveryCityDetails.view';

export default function AdminDeliveryCitiesRoutes() {
  return (
    <React.Fragment>
      <Route
        exact
        path={ADMIN_DELIVERY_CITIES_APP_PATHS.DELIVERY_CITIES_LIST}
        component={AdminDeliveryCitiesListView}
      />
      <Route
        exact
        path={ADMIN_DELIVERY_CITIES_APP_PATHS.DELIVERY_CITY_DETAILS}
        component={AdminDeliveryCityDetailsView}
      />
    </React.Fragment>
  );
}
